import { InjectionToken } from '@angular/core';
// eslint-disable-next-line import/no-extraneous-dependencies
import Pubnub from 'pubnub';

export type PubnubFactory = (c: Pubnub.PubnubConfig) => Pubnub;
export const PUBNUB_FACTORY = new InjectionToken<PubnubFactory>('PubNub SDK Factory');

export interface Bootstrap {
  meta_channel: string;
  pubnub_publish_key: string;
  pubnub_subscribe_key: string;
  pubnub_auth_token: string;
  auth_ttl_minutes: number;
  profile_uuid: string;
}
